import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./AnnouncementDetail.css";
import { PROGRAMS, BUCKET_URL } from "../../components/Home/Partner/Partner";

function AnnouncementDetail() {
  const { programId, announcementId } = useParams();
  const navigate = useNavigate();
  const [announcement, setAnnouncement] = useState(null);
  const [program, setProgram] = useState(null);

  useEffect(() => {
    const foundProgram = PROGRAMS.find((el) => el._id === programId);
    if (foundProgram && foundProgram.announcemenets) {
      const foundAnnouncement = foundProgram.announcemenets.find(
        (el) => el.id === announcementId
      );
      setAnnouncement(foundAnnouncement);
      setProgram(foundProgram);
    }
  }, [programId, announcementId]);

  if (!announcement || !program) {
    return <div>Loading...</div>;
  }

  return (
    <div className="announcement-detail">
      <div className="announcement-container">
        <button
          className="back-button"
          onClick={() => navigate(`/profile/${programId}`)}
        >
          ← Back to {program.title}
        </button>

        {/* Image Placeholder */}
        <div className="announcement-image-container">
          {announcement.image ? (
            <img
              src={`${BUCKET_URL}/${announcement.image}`}
              alt={announcement.title}
              className="announcement-image"
            />
          ) : (
            <div className="announcement-image-placeholder">
              <p>Announcement Poster</p>
            </div>
          )}
        </div>

        {/* Content */}
        <div className="announcement-content">
          <h1 className="announcement-title">{announcement.title}</h1>

          {announcement.subtitle && (
            <p className="announcement-subtitle">{announcement.subtitle}</p>
          )}

          {announcement.supportedBy && (
            <div className="announcement-section">
              <p className="announcement-supported">
                Supported by {announcement.supportedBy}
              </p>
            </div>
          )}

          {announcement.deadline && (
            <div className="announcement-highlight">
              <p>
                <strong>📌 Submission Deadline:</strong> {announcement.deadline}
              </p>
            </div>
          )}

          {announcement.description && (
            <div className="announcement-section">
              <p className="announcement-description">
                {announcement.description}
              </p>
            </div>
          )}

          {announcement.prizes && (
            <div className="announcement-section">
              <h3>💰 Cash Prizes:</h3>
              <ul className="announcement-list">
                {announcement.prizes.map((prize, index) => (
                  <li key={index}>{prize}</li>
                ))}
              </ul>
            </div>
          )}

          {announcement.entry && (
            <div className="announcement-highlight">
              <p>
                <strong>✅ {announcement.entry}</strong>
              </p>
            </div>
          )}

          {announcement.callToAction && (
            <div className="announcement-section">
              <p className="announcement-cta">{announcement.callToAction}</p>
            </div>
          )}

          {announcement.submitLink && (
            <div className="announcement-section">
              <p>
                <strong>Submit your video now:</strong>
              </p>
              <a
                href={announcement.submitLink}
                target="_blank"
                rel="noopener noreferrer"
                className="announcement-link"
              >
                {announcement.submitLink}
              </a>
            </div>
          )}

          {announcement.requirements && (
            <div className="announcement-section">
              <p className="announcement-requirements">
                {announcement.requirements}
              </p>
            </div>
          )}

          {announcement.facebookLink && (
            <div className="announcement-section">
              <a
                href={announcement.facebookLink}
                target="_blank"
                rel="noopener noreferrer"
                className="announcement-link"
              >
                View on Facebook
              </a>
            </div>
          )}

          {announcement.additionalInfo && (
            <div className="announcement-section">
              <p className="announcement-info">{announcement.additionalInfo}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AnnouncementDetail;
